var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isSystemAlert)?_c('b-alert',{staticClass:"alert",attrs:{"show":"","variant":"danger"}},[_c('i18n',{attrs:{"path":"description.systemAlert","tag":"div"}},[_c('br')])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }